<template>
    <div id="timeline">
        <div class="day-select-item">
            <div class="day-select">
                <select v-model="selected_day">
                    <option v-for="day in days" :value="day" :key="day">{{day}}</option>
                </select>
                <div class="down-icon">
                    <i class="fa fa-angle-down" aria-hidden="true"></i>
                </div>
            </div>
        </div>
        <!-- <div class="schedules"> -->
            <template class="schedules">
                <template v-if="schedules && Object.keys(schedules) != 0">
                    <div class="timeline-item" :class="{active:lecture.startTime == current_lecture.startTime && selected_day==today}" v-for="lecture in schedules[selected_day]" :key="lecture.startTime">
                        <div class="subject">{{lecture.subject}}</div>
                        <div class="time">{{lecture.startTime}}-{{lecture.endTime}}</div>
                    </div>
                </template>
                <template v-else>
                    <div class="timeline-item skeleton-item loader" v-for="i in 3" :key="i">                       
                        <content-loader
                            :speed="1"
                            primaryColor="#cccccc"
                            secondaryColor="#ecebeb"
                        >
                            <rect x="100" y="25" rx="6" ry="4" width="250" height="15" /> 
                            <rect x="100" y="100" rx="6" ry="4" width="250" height="15" /> 
                            
                        </content-loader>
                    </div>
                </template>
            </template>
        <!-- </div> -->

    </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';
import { get_faculty_schedules,get_student_schedules } from '../services/schedule'
export default {
    data(){
        return {
            days: [ "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],
            selected_day:"Monday",
            today:"",
            schedules:{},
        }
    },
    components:{
            ContentLoader

    },
    computed: {
        time(){
            return this.$store.state.time
        },
        current_lecture(){
            if(this.today){
                let day = this.today
                let todaySchedule = this.schedules[day]
                let current_time = this.time
                let hh = current_time.getHours(),
                    mm = current_time.getMinutes(),
                    ss = current_time.getSeconds()
                    for(let i=0;i<this.schedules[day].length;i++){
                        let lecture = this.schedules[day][i]

                        if(Date.parse(`01/01/2000 ${lecture.endTime}:00`) >= Date.parse(`01/01/2000 ${hh}:${mm}:${ss}`)){
                            // console.log("Next lecture ",lecture.subject,"at ",lecture.startTime)
                            this.$store.commit("set_lecture",lecture)
                            return lecture
                        }
                    }
            }
            return false
        }
    },
    async mounted() {

        let role = localStorage.getItem('role')
        if(role.toLowerCase() == 'faculty'){
            let faculty = JSON.parse(localStorage.getItem('user'))
            console.log("faculty ",faculty)
            let facultyId = faculty.uid
    
            let dayIndex = new Date().getDay()
            if(dayIndex != 0){
                this.today = this.days[dayIndex-1]
                // this.today = "Thursday"
                this.selected_day  = this.today
                console.log("Day is ",this.today)
            }
    
            console.log('schedules' in localStorage)
            // if ('schedules' in localStorage ){
            //     let schedules = JSON.parse(localStorage.getItem('schedules'))
            //     this.schedules = schedules
            // }
            // else{
                get_faculty_schedules(facultyId).then(res=>{
                    this.schedules = res.data.schedules
                    console.log("schedule",res)
                    localStorage.setItem('schedules',JSON.stringify(this.schedules))
                })
            // }
        }
        else{
            let student = JSON.parse(localStorage.getItem('user'))
            console.log("Student  ",student)
            let studentId = student.uid
            let batch = student.batch,year=student.year
    
            let dayIndex = new Date().getDay()
            if(dayIndex != 0){
                this.today = this.days[dayIndex-1]
                // this.today = "Thursday"
                this.selected_day  = this.today
                console.log("Day is ",this.today)
            }
    
            // console.log('schedules' in localStorage)
            // if ('schedules' in localStorage ){
            //     let schedules = JSON.parse(localStorage.getItem('schedules'))
            //     this.schedules = schedules
            // }
            // else{
                get_student_schedules(batch,year).then(res=>{
                    this.schedules = res.data.schedules
                    console.log("schedule",res)
                    localStorage.setItem('schedules',JSON.stringify(this.schedules))
                })
            // }
        }
        
    },
    
    

}
</script>

<style scoped>
.loader{
    height: 100%;
    width:12rem;
    height: 100%;
    
}
.loader>*{
    width:12rem;
}
#timeline{
    position: relative;
    width:100%;
    height: 5rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f8f8f8;    
    overflow-x: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

}
.day-select-item{
    width: 15rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 2rem;
    border-right: 2px solid #eeeeee;
    
}
.day-select{position: relative;}
.day-select select{
    padding: .5rem 1rem;
    font-size: 1.6rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 11rem;
    /* padding-right: 3rem; */
    outline: none;
    background-color: #002486;
    color:white
}
.day-select select::-ms-expand{display: none;}
.day-select .down-icon{
    position: absolute;
    top:50%;
    right:.8rem;
    transform: translateY(-50%);
}

option{
    background-color: #eeeeee;
    color:#292929;
}
.down-icon i{
    color:white;
    font-size: 1.6rem;
}

.schedules{
    width: calc(100% - 15rem );
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.timeline-item{
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding:1rem 4rem;
    /* position: relative; */
}
.skeleton-item::after{display: none !important;}
.skeleton-item::before{display: none !important;}


/* .timeline-item::before{
    content:"";
    position: absolute;
    top:50%;
    left: 5%;
    height:1px;
    width: 90%;
    background-color: #f0efef;
}*/
.timeline-item::before{
    content:"";
    position: absolute;
    top:10%;
    left: 100%;
    height:80%;
    width: 1.5px;
    background-color: #eeeeee; 
}
.timeline-item>div{
    width: max-content;
    text-align: center;
    color: #707070;
}
.subject{
    font-size: 1.8rem;
    margin-bottom: .8rem;
}
.time{
    font-size: 1.4rem;
}
.active{ background-color: #002486 !important;}
.active>div{color:#ffffff !important;}
/* .active::after{
    content:"sadsda";
    position: absolute;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-top: 10px solid #002486;
    top:100%;
    left:50%;
    transform: translateX(-50%);
    z-index: 99;

} */

#timeline::-webkit-scrollbar {
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/components/Timeline.vue